module.exports = __webpack_public_path__ + "static/img_02-5225da1a8e12f1b7a102249498bd7471.png";